import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_VEHICLE,
   DELETE_VEHICLE,
   GET_VEHICLE,
   UPDATE_VEHICLE,
   GET_ONE_VEHICLE,
   MULTI_DELETE_VEHICLE,
} from '../types';

export const getVehicle = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/vehicle/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_VEHICLE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Vehicle. Please try again. :", err);
   }
};

export const addVehicle = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/vehicle/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_VEHICLE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Vehicle added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data)
         if (err.response && err.response.data && err.response.data.code === 1) {
            return;
         }
      const errorMessage = err.response?.data?.errors?.[0]?.message;
      toast.error(errorMessage || 'An error occurred. Please try again.');
      // if (err.response.status === 400) {
      //    toast.warn(err.response.data.message);
      //    return err.response.data;
      // }
      // if (err.response.data.errors[0].message) {
      //    toast.error(err.response.data.errors[0].message);
      // }
   }
};

export const updateVehicle = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/vehicle/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_VEHICLE, payload: res.data.data });

         setTimeout(() => {
            toast.success('Vehicle updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update Vehicle. Please try again.");
   }
};

// Delete Vehicle
export const deleteVehicle = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/vehicle/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_VEHICLE, payload: { id } });
         setTimeout(() => {
            toast.success('Vehicle deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Vehicle. Please try again.");
   }
};

export const multiDeleteVehicle = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/vehicle/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_VEHICLE, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getSingleVehicle = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/vehicle/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_VEHICLE, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
